import React, { useEffect } from "react";
import "./partner.css";
import AOS from "aos";
import "aos/dist/aos.css";

import Icon1 from "../../ASSETS/ICONS/equip.png";
import Icon2 from "../../ASSETS/ICONS/medstaff.png";
import Icon3 from "../../ASSETS/ICONS/patientcoord.png";
import Icon4 from "../../ASSETS/ICONS/adminsupport.png";

import IMG1 from "../../ASSETS/IMAGES/multidiv.png";
import IMG2 from "../../ASSETS/IMAGES/smartbeatdiag.png";
import IMG3 from "../../ASSETS/IMAGES/emraccess.png";
import IMG4 from "../../ASSETS/IMAGES/insuranceclaims.png";

import IMG_CI from "../../ASSETS/IMAGES/clinicintegration.png";
import IMG_SeamlessWF from "../../ASSETS/IMAGES/seamlessworkflow.png";
import IMG_WhiteGlove from "../../ASSETS/IMAGES/whiteglovepc.png";

const PartnerWithUs = () => {
  useEffect(() => {
    AOS.init({ duration: 900, once: true });
  }, []);

  return (
    <div className="partner-page">

      {/* HEADER */}
      {/* <section className="partner-header">
        <h1 data-aos="fade-up">Partner With Us</h1>
        <p data-aos="fade-up" data-aos-delay="100">
          Bringing preventive care and diagnostics directly into your clinic.
        </p>
      </section> */}

      {/* INTRO */}
      <section className="intro-section">
        <p data-aos="fade-up">
          We Deliver Advanced Diagnostic Services Directly to your Practice — Your Patients Never Leave your Clinic.
        </p>
      </section>

      {/* WHAT WE PROVIDE */}
      <section className="provide-section">
        {/* <h2 data-aos="fade-up">What KUR Diagnostics Provides</h2> */}

        <div className="provide-grid">
          <div className="provide-card" data-aos="fade-up">
            <img src={Icon1} className="pi-icon" />
            
            <p>Calibrated Equipment and Supplies at No Cost to the Practice</p>
          </div>

          <div className="provide-card" data-aos="fade-up" data-aos-delay="100">
            <img src={Icon2} className="pi-icon" />
            
            <p>
             Trained, Registered, and Certified Ultrasound Technicians, Cardio-Trained Technicians, Phlebotomists, and Medical Assistants.
            </p>
          </div>

          <div className="provide-card" data-aos="fade-up" data-aos-delay="150">
            <img src={Icon3} className="pi-icon" />
            
            <p>Centralized Patient Coordinators – Scheduling, Insurance verification & pre-qualification.</p>
          </div>

          <div className="provide-card" data-aos="fade-up" data-aos-delay="200">
            <img src={Icon4} className="pi-icon" />
            {/* <h3>Administrative & Backend Support</h3> */}
            <p>
              Backend Infrastructure and Administrative Support Teams for Seamless Report Generation & Upload to EMR, Insurance Reimbursement & Reclaim Processing.
            </p>
          </div>
        </div>

        {/* ENHANCED INFO SECTION */}
        <div className="info-section">
          <div className="info-card" >
            <div className="info-details">
              {/* <h3>Clinic Integration</h3> */}
              <p>We integrate into your clinic - Our staff becomes a part of your practice.</p>
            </div>
            {/* <img src={IMG_CI} className="info-img" /> */}
          </div>

          <div className="info-card" >
            <div className="info-details">
              {/* <h3>Seamless Workflow</h3> */}
              <p>Our workflow limits interruptions with the PI and the practice.</p>
            </div>
            {/* <img src={IMG_SeamlessWF} className="info-img" /> */}
          </div>

          <div className="info-card" >
            <div className="info-details">
              {/* <h3>White-Glove Patient Experience</h3> */}
              <p>Think of us as a new service line - White glove patient care delivered by skilled professionals for a comfortable experience.</p>
            </div>
            {/* <img src={IMG_WhiteGlove} className="info-img" /> */}
          </div>
          <div className="info-card" >
            <div className="info-details">
              {/* <h3>White-Glove Patient Experience</h3> */}
              <p>We partner with you to unlock high-value ancillary services to generate incremental revenue for your organization.</p>
            </div>
            {/* <img src={IMG_WhiteGlove} className="info-img" /> */}
          </div>
          
           </div>
      </section>

      {/* PRACTICE OBLIGATIONS */}
        <h2 className="ob-title" >Practice Obligations for a Successful in Clinic Model</h2>
      <section className="ob-section">
        <div className="ob-row">
          <img src={IMG1} className="ob-img" />
          <div className="ob-content">
            <h3>Multi-Physician Practice</h3>
            {/* <p>Designed for clinics with multiple physicians to support ongoing diagnostics.</p> */}
          </div>
        </div>

        <div className="ob-row ob-reverse">
          <img src={IMG2} className="ob-img" />
          <div className="ob-content">
            <h3>Dedicated Screening Room</h3>
            {/* <p>Ensures accuracy, privacy, and smooth patient flow.</p> */}
          </div>
        </div>

        <div className="ob-row">
          <img src={IMG3} className="ob-img" />
          <div className="ob-content">
            <h3>EMR Access</h3>
            {/* <p>Secure access for KUR specialists to upload reports directly.</p> */}
          </div>
        </div>

        <div className="ob-row ob-reverse">
          <img src={IMG4} className="ob-img" />
          <div className="ob-content">
            <h3>Insurance Reimbursement Support</h3>
            {/* <p>Clinic team initiates reimbursements and collaborates for claim resolution.</p> */}
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section className="contact1-section">
        <h2>If you are interested learning more</h2>

        <div className="contact1-box">
          <p><strong>Email:</strong> info@kurdiagnostics.com</p>
          <p><strong>Phone:</strong> +1 (866) 300 5380</p>
        </div>

        <button
          className="contact1-btn"
          onClick={() => (window.location.href = "/contact")}
        >
          Contact Us
        </button>
      </section>
    </div>
  );
};

export default PartnerWithUs;
